import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import NavSocial from "./nav-social";

export default function NavFooter({ children }) {
  const data = useStaticQuery(graphql`
    query {
      site {
        buildYear: buildTime(formatString: "yyyy")
      }
    }
  `);

  // TODO: Add links to Privay Policy and Cookies Policy
  return (
    <div className="bg-secondary-light p-4">
      <div className="mx-auto px-2 sm:px-4 relative flex flex-col sm:flex-row sm:items-center justify-between">
        <div className="flex flex-1 justify-center md:justify-start text-primary">
          <div className="flex m-2 flex-wrap">
            <p className="text-sm pr-1">{`© ${data.site.buildYear} Lost With Lydia`}</p>
            <p className="text-sm">All Rights Reserved</p>
          </div>
        </div>

        <div className="flex flex-1 justify-center pl-2 pr-2">
          <div className="flex">
            <Link to="/privacy" className="text-primary p-2 text-sm">
              Privacy Policy
            </Link>
            <a href="/tos" className="text-primary p-2 text-sm">
              Terms of Service
            </a>
          </div>
        </div>

        <div className="flex flex-1 justify-center md:justify-end">
          <NavSocial className="text-primary text-2xl" />
        </div>
      </div>
    </div>
  );
}
